namespace('compass.tiles');

compass.require('compass.hotel.GroupLandingCustomizationWidget');

compass.tiles.GroupInvitationTileWidget = compass.defineWidget(function InvitationTile (options) {
	var $j = jQuery;
	var _settings = options;
	var sharing = _settings.share_settings;		

	/* accessibilty structure */
	var accessibilty = {
		TAB_INDEX: 0
	};

	var _LABELS = {
		"CUSTOMIZE": "Customize",
		"SAVE": "Save"
	};
	var _POPUP_WIDTH = 500;
	var _POPUP_HEIGHT = 300;

	var me = this;
	var d = jQuery.dom.getContext(this);

	var buildHTML = function(widgetElem) {
		widgetElem.append(
			d.div({ className: 'smallTile tile', tabindex: accessibilty.TAB_INDEX},
				makeLead(),
				makeExplanation()
			)
		).activate(generatePopup);
	};
	this.render = this.build = buildHTML;

	var _popup, _summary, _customization;
	var generatePopup = me.generatePopup = function () {
		var groupName = _settings.groupName ? "&nbsp;" + _settings.groupName + "." : "."; 
		var popupTitle = "Share Your Group";
		var leadText = "Invite colleagues to select a guest room from your group " + 
						"inventory and manage their own reservation as part of your group" + groupName;
		var url = compass.rootPrefix + '/' + _settings.meetingInfo.meetingCode + sharing.url;
		var step1 = "Compose intro message for your Group RSVP website and configure your landing page by clicking customize.";
		var step2 = "Copy this link and send to anyone you'd like to invite to join your group. Group RSVP Link:";
		var step3 = "Guests select their room, enter their contact info, hotel requests and individual password. Based on your preferences, guests would also enter a payment guarantee for their own room at this point.";

		_summary = d.div({
			className : "summary"
		}, d.div({className : "leadText"}, leadText),
			d.div({className : "stepsTitle"}, "Steps"),
			d.ol({className : "stepsList"}, 
				d.li({className : "step"}, step1),
				d.li({className : "step"}, step2),
				d.a({href: url, target: "_blank", className : "link"}, window.location.protocol + '//' + window.location.host + url),
				d.li({className : "step"}, step3)
			),
			d.button({
				className: 'secondaryButton'
			}, _LABELS.CUSTOMIZE).activate(
				function (event) {
					showCustomization();
				}
			)
		);

		_customization = d.div({
			className: "customization"
		});

		var popup = d.div({ className : "header" },
				d.div({ className : "headerTitle" }, popupTitle)
			);

		popup.append(d.div({ className : "popupBody" },
			_summary,
			_customization
		));


		_customizationWidget = new compass.hotel.GroupLandingCustomizationWidget(
			_customization, {
				values: _settings.values,
				meetingInfo: _settings.meetingInfo
			}
		);
		_customization.append(d.button({
				className: 'secondaryButton'
			}, _LABELS.SAVE).activate(function () {
				var customizationWidgetData = _customizationWidget.getData();
				if(_settings.values && _settings.values.rules){
					_settings.values.rules.creditCard = customizationWidgetData.options.credit_card;
				}
				me.trigger('GroupInvitationTileWidget.customizationsSaved', customizationWidgetData);
				hideCustomization();
			})
		);

		_popup = d.dialog({
			classes: "GroupInvitationTileWidget",
			contents: popup,
			width: _POPUP_WIDTH//,
			//height: _POPUP_HEIGHT
		});

		/* this needs to get moved to the view.*/
		compass.trackPageView('RsvpConfigurationWindow', {
			src : 'arctic.views.individual.groupFrontDesk'
		});
	};

	var _SLIDE_SPEED = 900;
	var showCustomization = function () {
		compass.trackPageView('RsvpCustomization');
		_summary.parent().animate({
			left: _POPUP_WIDTH*-1 -100
		}, _SLIDE_SPEED);
	};
	var hideCustomization = function () {
		_summary.parent().animate({
			left: 0
		}, _SLIDE_SPEED);
	};

	var makeLead = function () {
		var lead_text = "Group RSVP";
		var lead = d.h3({ className: 'tileTitle' }, lead_text);

		return lead;
	};

	var makeExplanation = function () {
		var explanation_text = "Invite colleagues to select a room from your group inventory and manage their own reservation.";
		var expl = d.div({ className: 'tileExplanation','aria-role' : 'button', role : 'button' }, explanation_text);

		return expl;
	};
}, {
	WUID: 'DEFAULT',
	widgetName: 'GroupInvitationTileWidget'
});

